import { render, staticRenderFns } from "./bottledByOnly.vue?vue&type=template&id=3428b79a&"
import script from "./bottledByOnly.vue?vue&type=script&lang=js&"
export * from "./bottledByOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/one-stop-shop/one-stop-shop/one-stop-shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3428b79a')) {
      api.createRecord('3428b79a', component.options)
    } else {
      api.reload('3428b79a', component.options)
    }
    module.hot.accept("./bottledByOnly.vue?vue&type=template&id=3428b79a&", function () {
      api.rerender('3428b79a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/wp-content/themes/global-theme/views/blocks/personalisationOverlay/bottledByOnly.vue"
export default component.exports